import React from 'react';
import { Typography } from '@material-ui/core';
import SearchField from '../Util/SearchField';
import DateRangePicker from '../Util/DateRangePicker';
import SelectPitch from '../Util/SelectPitch';
import SelectToBeApprovedOnly from '../Util/SelectToBeApprovedOnly';
import { Moment } from 'moment';

interface Props {
  search?: string;
  onSearchChange: (val: string) => void;
  creationDateRange: { startDate: Moment | null; endDate: Moment | null };
  onCreationDateRangeChange: (arg: { startDate: Moment | null; endDate: Moment | null }) => void;
  completedOnly: boolean;
  onCompletedOnlyChange: (completedOnly: boolean) => void;
  pitches: { [key: string]: boolean };
  onPitchesChange: (pitches: { [key: string]: boolean }) => void;
  toBeApprovedOnly: boolean;
  onToBeApprovedOnlyChange: (checked: boolean) => void;
}

const SessionsFilter: React.FunctionComponent<Props> = (props) => {
  return (
    <div className="sciui-bg-p-4 sciui-m-y-m sciui-p-m">
      <div className="sciui-m-y-m">
        <Typography variant="h4">Filter</Typography>
      </div>
      <SearchField key="search" value={props.search} onChange={props.onSearchChange} />
      <SelectToBeApprovedOnly onChange={props.onToBeApprovedOnlyChange} value={props.toBeApprovedOnly}  />
      <DateRangePicker
        title="Creation date"
        value={props.creationDateRange}
        onChange={props.onCreationDateRangeChange}
      />
      <SelectPitch pitches={props.pitches} onPitchesChange={props.onPitchesChange} />
    </div>
  );
};

export default SessionsFilter;
